/**
 * wishlist.js — localStorage-based wishlist.
 * Stores product handles in localStorage.
 * Dispatches kaqaz:wishlist-updated after each change.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'kaqaz_wishlist';

  function getAll() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function save(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('kaqaz:wishlist-updated', { detail: { items: items } }));
    updateBadges(items);
    updateButtons();
  }

  function add(handle) {
    var items = getAll();
    if (items.indexOf(handle) === -1) {
      items.push(handle);
      save(items);
    }
  }

  function remove(handle) {
    var items = getAll().filter(function (h) { return h !== handle; });
    save(items);
  }

  function toggle(handle) {
    if (isInWishlist(handle)) {
      remove(handle);
    } else {
      add(handle);
    }
  }

  function isInWishlist(handle) {
    return getAll().indexOf(handle) !== -1;
  }

  function getCount() {
    return getAll().length;
  }

  /* ---- UI updates -------------------------------------------------- */

  function updateBadges(items) {
    var badges = document.querySelectorAll('.wishlist-badge');
    var count = items ? items.length : getCount();
    badges.forEach(function (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function updateButtons() {
    var items = getAll();
    document.querySelectorAll('.wishlist-btn').forEach(function (btn) {
      var handle = btn.getAttribute('data-wishlist-handle');
      if (!handle) return;
      var isActive = items.indexOf(handle) !== -1;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-label', isActive ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  /* ---- Event delegation for wishlist buttons ----------------------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.wishlist-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-wishlist-handle');
    if (handle) toggle(handle);
  });

  /* ---- Init on DOM ready ------------------------------------------ */

  document.addEventListener('DOMContentLoaded', function () {
    updateBadges();
    updateButtons();
  });

  /* ---- Expose to global scope ------------------------------------- */

  window.kaqazWishlist = {
    add: add,
    remove: remove,
    toggle: toggle,
    isInWishlist: isInWishlist,
    getAll: getAll,
    getCount: getCount
  };

})();
